import { ApiClient } from 'lib/api/ApiClient.types';
import {
  CreateResourceTypeInput,
  ResourceTypeApi,
  throwResourceTypesListUnavailable,
  UpdateResourceTypePatch
} from './resource-types.api';
import { parseResourceType } from './resource-types.http.schema';

export function createResourceTypeApi(client: ApiClient): ResourceTypeApi {
  return {
    list: async () => throwResourceTypesListUnavailable(),
    get: async id => {
      const response = await client.get(`/resource_types/${id}`, {
        token: true
      });
      return parseResourceType(response);
    },
    create: async (input: CreateResourceTypeInput) => {
      const response = await client.post('/resource_types', {
        data: {
          name: input.name,
          icon: input.icon,
          // Backend field is historically named `model`.
          model: input.mechanism
        },
        token: true
      });
      return parseResourceType(response);
    },
    update: async (id, patch: UpdateResourceTypePatch) => {
      const response = await client.put(`/resource_types/${id}`, {
        data: {
          id,
          ...patch
        },
        token: true
      });
      return parseResourceType(response);
    },
    remove: async id => {
      await client.del(`/resource_types/${id}`, { token: true });
    },
    reorder: async items => {
      await client.put('/reorder/resource_types', {
        data: {
          reorder: items.map(item => ({
            id: item.id,
            order: item.order
          }))
        },
        token: true
      });
    }
  };
}
